import React, { useEffect } from 'react';
import './App.css';
import MainLayout from './components/MainLayout';
import { Route, Routes, useLocation } from 'react-router-dom';
import SignUpPage from './pages/SignUp';
import SignInPage from './pages/SignIn';
import CartPage from './pages/Cart';
import CheckoutPage from './pages/Checkout';
import NavigationBar from './components/elements/NavigationBar.tsx';
import ThankYouPage from './pages/ThankYouPage.tsx';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { SignModalProvider } from './contexts/SignModalContext.tsx';
import EventPage from './pages/EventPage.tsx';
import { SettingsProvider } from './contexts/SettingsContext';
import SettingsLoader from './contexts/SettingsLoader.tsx';
import EventLocationPicker from './pages/EventLocationPicker/EventLocationPicker.tsx';
import { trackUtmParams } from './utils';

const AppContent: React.FC = () => {
  const location = useLocation();

  // Track UTM parameters whenever the location changes
  useEffect(() => {
    trackUtmParams();
  }, [location]);

  return (
    <>
      <Routes>
        <Route path="/kids-co/locations" element={<EventLocationPicker />} />
        <Route path="*" element={<NavigationBar />} />
      </Routes>
      <Routes>
        <Route path="/" element={<MainLayout />} />
        <Route path="/signup" element={<SignUpPage />} />
        <Route path="/signin" element={<SignInPage />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/thank-you" element={<ThankYouPage />} />
        <Route path="/event/:id" element={<EventPage />} />
      </Routes>
    </>
  );
};

const App: React.FC = () => {
  const recaptcha_key = import.meta.env.VITE_RECAPTCHA_KEY;

  return (
    <GoogleReCaptchaProvider reCaptchaKey={recaptcha_key}>
      <SettingsProvider>
        <SettingsLoader>
          <SignModalProvider>
            <AppContent />
          </SignModalProvider>
        </SettingsLoader>
      </SettingsProvider>
    </GoogleReCaptchaProvider>
  );
};

export default App;
